import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { routesList } from "../Common";
import BabyMint from "../Components/BabyMint";
import Footer from "../Components/Footer";
import HeaderContainer from "../Components/HeaderContainer";
import HomePage from "../Components/HomePage";
import SuperBabyMint from "../Components/SuperBabyMint";
import TokenHolderSection from "../Components/TokenHolderSection";
import Utilities from "../Components/Utilities";

export default function Routing() {
  return (
    <Router>
      <Routes>
        <Route
          exact
          path={routesList.homePage}
          element={
            <>
              <HeaderContainer />
              <HomePage />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path={routesList.mint}
          element={
            <>
              <HeaderContainer />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path={routesList.token_registration}
          element={
            <>
              <HeaderContainer />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path={routesList.token_holder}
          element={
            <>
              <HeaderContainer />
              <TokenHolderSection />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path={routesList.baby_mint}
          element={
            <>
              <HeaderContainer />
              <BabyMint />
              <Footer />
            </>
          }
        />
        <Route
          exact
          path={routesList.super_baby_mint}
          element={<SuperBabyMint />}
        />
        {/* <Route
          exact
          path={routesList.utilities}
          element={
            <>
              <HeaderContainer />
              <Utilities />
              <Footer />
            </>
          }
        /> */}

        <Route
          exact
          path={"*"}
          element={
            <>
              <div className={"top mint-header"}>
                <div className="text-center">
                  <h1>404</h1>
                  <h2 className="mt-3">
                    The page you are requested is "not found"
                  </h2>
                </div>
                <div className="text-center mt-5">
                  <a href={routesList.homePage} className="btn">
                    Back to Home
                  </a>
                </div>
              </div>
            </>
          }
        />
      </Routes>
    </Router>
  );
}
